import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-container mx-auto px-4 py-8">
      <div className="text-center">
        <h1 className="text-4xl font-extrabold text-primeColor mb-4 leading-tight">
          {t("home.Welcome_toـKayanـStore")}
        </h1>
        <p className="text-lg text-gray-600 max-w-xl mx-auto mb-6">
          {t("home.Kayan_Shop_detail")}
        </p>
        <Link to="/shop">
          <button className="px-6 py-3 bg-primeColor text-white rounded-lg shadow-md hover:bg-black hover:shadow-lg transition duration-300">
            {t("home.Continue_Shopping")}
          </button>
        </Link>
      </div>
    </div>
  );
};

export default About;
